import { computed } from 'vue';
import { LoadingStatuses } from '@/models/loading.interface';
import store from '@/store';

export default class RightsUsersCode {
	public isLoading = computed((): boolean => {
		const loadingStatus = store.getters.loadingStatusRights();
		return loadingStatus === LoadingStatuses.ACTIVE;
	});
}
